import { gql } from '@apollo/client';

export const replaceDocument = gql`
  mutation ReplaceDocument(
    $file: Upload!,
    $creditStudyId: String!,
    $documentId: String!
  ) {
    replaceDocument(
      file: $file,
      creditStudyId: $creditStudyId,
      documentId: $documentId
    ) {
      value
    }
  }
`;